import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';

const TAG = 'AmapText';

@Injectable()
export class AmapTextService implements Getter<AMap.Text> {
  private text: AMap.Text;
  private text$ = new ReplaySubject<AMap.Text>(1);

  constructor(private amaps: AMapService, private logger: LoggerService, private ngZone: NgZone) {}

  /**
   * è·åç¹æ è®°
   */
  get() {
    return this.text$.asObservable();
  }

  /**
   * åå»ºç¹æ è®° AMap.Text
   * @param options éé¡¹
   * @param addToMap æ¯å¦ç´æ¥å è¿å°å¾
   */
  create(options: AMap.Text.Options, addToMap = true) {
    return this.amaps.get().pipe(
      map(m => {
        if (addToMap) {
          options.map = m;
        }
        this.text = this.ngZone.runOutsideAngular(() => new AMap.Text(options));
        this.logger.d(TAG, 'new text created.');
        this.text$.next(this.text);
        this.text$.complete();
        return this.text;
      }),
    );
  }

  /**
   * éæ¯ç¹æ è®°
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'text destroyed.');
      this.text = null;
    });
  }
}
